import { render, staticRenderFns } from "./BasicDropdown.vue?vue&type=template&id=40a8b3ca&"
import script from "./BasicDropdown.vue?vue&type=script&lang=js&"
export * from "./BasicDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports